import { useCallback, useState } from 'react';
import { useDeferredUnmount } from '@/experiences/sales-portal/blocs/hooks/use-deferred-unmount';

interface UseOrderEntryMobileFulfillmentPickerResult {
  closePicker: () => void;
  isPickerOpen: boolean;
  openPicker: () => void;
  shouldRenderPicker: boolean;
}

/** Owns the open state of the mobile fulfillment push view and defers its unmount. */
export const useOrderEntryMobileFulfillmentPicker =
  (): UseOrderEntryMobileFulfillmentPickerResult => {
    const [isPickerOpen, setIsPickerOpen] = useState(false);
    const shouldRenderPicker = useDeferredUnmount(isPickerOpen);

    const openPicker = useCallback(() => setIsPickerOpen(true), []);
    const closePicker = useCallback(() => setIsPickerOpen(false), []);

    return { closePicker, isPickerOpen, openPicker, shouldRenderPicker };
  };
